function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { getFilter } from 'swag-client-common/utils/tricks';
import { IconButton } from 'swag-client-common/components/ui/icon-button';
import { variables } from 'swag-client-common/styles/variables-js';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { ProductsSortingOptions } from '../products-sorting-options';
import classes from './products-sorting.scss';
import { styles } from './popover-settings';
export class ProductsSorting extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "innerRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "timeout", null);
    _defineProperty(this, "handleKeyDown", event => {
      const {
        openSorting
      } = this.props;
      handleOnEnterPressed(event, () => openSorting(event));
    });
    _defineProperty(this, "handleMenuClose", () => {
      this.timeout = setTimeout(() => {
        if (this.innerRef.current) {
          return this.innerRef.current.focus();
        }
        return null;
      }, 100);
    });
  }
  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  render() {
    const {
      sorting,
      isOpen,
      anchorEl,
      openSorting,
      closeSorting,
      sortProducts,
      targetOrigin,
      anchorOrigin,
      categoriesAndFiltersAreHiddenForCBS
    } = this.props;
    _extends(styles.selectedItem, {
      backgroundColor: variables.colorAlternativePrimary
    });
    if (categoriesAndFiltersAreHiddenForCBS) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.container,
      onClick: openSorting,
      onKeyDown: this.handleKeyDown,
      tabIndex: 0,
      ref: this.innerRef,
      "aria-label": "Sort"
    }, /*#__PURE__*/React.createElement(IconButton, {
      iconClassName: classes.icon,
      buttonClassName: classes.button,
      dataButton: "Sort by",
      dataTooltip: getFilter(sorting),
      tooltipDirection: "right",
      tooltipClassName: classes.tooltip,
      isButtonTag: false
    }), /*#__PURE__*/React.createElement("span", {
      className: classes.label
    }, "Sort by"), /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.label, classes.sortingName)
    }, getFilter(sorting, true))), /*#__PURE__*/React.createElement(ProductsSortingOptions, {
      isOpen: isOpen,
      anchorEl: anchorEl,
      anchorOrigin: anchorOrigin,
      targetOrigin: targetOrigin,
      onRequestClose: closeSorting,
      onChange: sortProducts,
      sorting: sorting,
      handleMenuClose: this.handleMenuClose
    }));
  }
}